import React, { useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';

// The category number is given by the server, so users only type the description.
export function CategoryForm({ category, saving, error, onClose, onSave }) {
    const [description, setDescription] = useState(category?.description || '');

    return (
        <Modal show onHide={saving ? undefined : onClose} backdrop={saving ? 'static' : true} keyboard={!saving} aria-labelledby="category-form-title">
            <Form onSubmit={event => { event.preventDefault(); onSave({ description: description.trim() }); }}>
                <Modal.Header closeButton={!saving}>
                    <Modal.Title id="category-form-title">{category ? 'Edit category' : 'Add category'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <fieldset disabled={saving}>
                        <Form.Group controlId="category-description">
                            <Form.Label>Category description</Form.Label>
                            <Form.Control required autoFocus maxLength={200} pattern=".*\S.*" value={description} onChange={event => setDescription(event.target.value)} />
                            {category && <Form.Text>All machines in this category will show the new description.</Form.Text>}
                        </Form.Group>
                    </fieldset>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" disabled={saving} onClick={onClose}>Cancel</Button>
                    <Button type="submit" disabled={saving}>{saving ? 'Saving…' : category ? 'Save changes' : 'Create category'}</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}
